var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _g, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _rect3, _path104, _path105, _path106;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyAuditTrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 135,
    viewBox: "0 0 146 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.21875,
    y: 61.582,
    width: 145.465,
    height: 5.21908,
    fill: "#407BFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.21875,
    y: 61.582,
    width: 38.9319,
    height: 5.21908,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7734 66.8008H36.3867L38.1593 132.213H39.7734H41.3875L43.1644 66.8008H39.7734Z",
    fill: "#407BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.1583 132.213H39.7724V68.2051L36.4414 68.813L38.1583 132.213Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67184 66.8008H4.28516L6.05771 132.213H7.67184H9.28598L11.0585 66.8008H7.67184Z",
    fill: "#407BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.05711 132.213H7.67125V68.2051L4.33594 68.813L6.05711 132.213Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.23 66.8008H134.844L136.616 132.213H138.23H139.845L141.621 66.8008H138.23Z",
    fill: "#407BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M136.615 132.213H138.229V68.2051L134.898 68.813L136.615 132.213Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.129 66.8008H102.742L104.515 132.213H106.129H107.743L109.516 66.8008H106.129Z",
    fill: "#407BFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.518 132.213H106.132V68.2051L102.801 68.813L104.518 132.213Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2659 33.642H34.6797C34.1104 33.6195 33.5646 33.8707 33.2115 34.3178C32.8584 34.7649 32.7405 35.354 32.8943 35.9026L37.5012 57.8878C37.8058 59.1654 38.9206 60.0863 40.2328 60.1441H74.8447C75.413 60.1662 75.9577 59.9156 76.3107 59.4696C76.6636 59.0236 76.7823 58.4358 76.6301 57.8878L72.0189 35.9026C71.7137 34.6159 70.5874 33.691 69.2659 33.642Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5345 58.8898C39.6495 58.83 38.9033 58.2082 38.6849 57.3485L34.078 35.3633C33.9981 35.0686 34.0564 34.7536 34.2364 34.507C34.4231 34.2958 34.6956 34.1809 34.9771 34.1944H69.589C70.4739 34.2542 71.2202 34.8761 71.4386 35.7358L76.0455 57.7209C76.1254 58.0156 76.0671 58.3306 75.8871 58.5772C75.7015 58.79 75.4282 58.9053 75.1464 58.8898H40.5345Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M66.6453 57.1294L62.2782 36.283C62.2285 36.0332 62.2926 35.7741 62.4532 35.5763C62.6137 35.3786 62.854 35.2625 63.1088 35.2598H68.7262C69.1273 35.2629 69.4725 35.544 69.5568 35.9362L73.9239 56.7654C73.9736 57.0153 73.9095 57.2743 73.7489 57.4721C73.5884 57.6699 73.3481 57.786 73.0933 57.7887H67.4759C67.0799 57.7874 66.7364 57.5148 66.6453 57.1294Z",
    fill: "#407BFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9579 37.0831L36.7695 36.1797H43.7056L43.894 37.0831H36.9579Z",
    fill: "#407BFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.161 39.3272L39.9727 38.4238H52.1279L52.3206 39.3272H40.161Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.802 41.5665L40.6094 40.6631H54.2375L54.4259 41.5665H40.802Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4423 43.8096L41.2539 42.9062H52.2232L52.4158 43.8096H41.4423Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0677 47.4444L38.875 46.541H43.2636L43.452 47.4444H39.0677Z",
    fill: "#407BFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2665 49.6846L42.0781 48.7812H47.4215L47.6141 49.6846H42.2665Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8958 49.6846L48.7031 48.7812H54.0507L54.2391 49.6846H48.8958Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.911 51.9268L42.7227 51.0234H60.7907L60.9791 51.9268H42.911Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5478 54.1671L43.3594 53.2637H57.1373L57.3257 54.1671H43.5478Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4237 60.0107H39.8854C38.6437 60.0107 37.8388 60.7172 38.1 61.582H88.1553C87.8984 60.7172 86.6653 60.0107 85.4237 60.0107Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.9222 28.0849L20.5508 7.2514C20.5025 7.00218 20.5673 6.7444 20.7277 6.54763C20.8881 6.35087 21.1276 6.23541 21.3814 6.23242H56.7468C57.1466 6.23507 57.4914 6.5141 57.5774 6.90461L61.9488 27.721C61.9985 27.9708 61.9344 28.2299 61.7738 28.4276C61.6133 28.6254 61.373 28.7415 61.1182 28.7442H25.7528C25.3568 28.743 25.0133 28.4703 24.9222 28.0849Z",
    fill: "#407BFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4935 6.91684H30.0693L29.9023 6.11621H37.3265L37.4935 6.91684Z",
    fill: "#407BFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.2875 8.19321H33.3076L33.1406 7.39258H36.1206L36.2875 8.19321Z",
    fill: "#407BFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.2451 8.19321H36.6553L36.4883 7.39258H41.0781L41.2451 8.19321Z",
    fill: "#407BFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.2452 9.46469H33.5732L33.4062 8.66406H43.0825L43.2452 9.46469Z",
    fill: "#407BFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.0166 10.7401H33.8389L33.6719 9.93945H41.8496L42.0166 10.7401Z",
    fill: "#407BFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.4407 24.2734H42.2344L42.4014 25.0698H47.6077L47.4407 24.2734Z",
    fill: "#407BFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9486 22.5272H33.3232L33.1562 21.7266H40.7816L40.9486 22.5272Z",
    fill: "#407BFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.016 25.5449H36.9258L37.0928 26.3456H44.183L44.016 25.5449Z",
    fill: "#407BFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.8665 24.2734H36.6602L36.8271 25.0698H42.0335L41.8665 24.2734Z",
    fill: "#407BFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.8072 22.998H36.3945L36.5615 23.7987H46.9742L46.8072 22.998Z",
    fill: "#407BFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2314 0.974082H28.831L28.6641 0.177734H37.0644L37.2314 0.974082Z",
    fill: "#407BFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.3824 3.99609H32.1172L32.2842 4.79672H41.5451L41.3824 3.99609Z",
    fill: "#407BFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.5283 2.72461H31.8516L32.0185 3.52096H39.6953L39.5283 2.72461Z",
    fill: "#407BFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.0377 1.44922H31.5859L31.7529 2.24985H40.2046L40.0377 1.44922Z",
    fill: "#407BFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1398 12.8123H31.2998L31.1328 12.0117H36.9728L37.1398 12.8123Z",
    fill: "#407BFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.3087 15.8301H34.8984L35.0654 16.6307H46.4714L46.3087 15.8301Z",
    fill: "#407BFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.3596 14.5586H34.6328L34.7998 15.3592H39.5266L39.3596 14.5586Z",
    fill: "#407BFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.4885 14.5586H39.7617L39.9287 15.3592H44.6555L44.4885 14.5586Z",
    fill: "#407BFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.7799 13.2832H34.3672L34.5342 14.0838H44.9426L44.7799 13.2832Z",
    fill: "#407BFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.7593 19.6543H35.6953L35.8623 20.4506H44.9263L44.7593 19.6543Z",
    fill: "#407BFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.0671 18.3779H35.4297L35.5967 19.1786H38.2298L38.0671 18.3779Z",
    fill: "#407BFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.1892 18.3779H38.4258L38.5928 19.1786H42.3562L42.1892 18.3779Z",
    fill: "#407BFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45.5767 17.1064H35.1641L35.331 17.9028H45.7437L45.5767 17.1064Z",
    fill: "#407BFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.7751 16.8924H50.0459L49.8789 16.0918H53.6124L53.7751 16.8924Z",
    fill: "#407BFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.9831 16.8924H54.2373L54.0703 16.0918H59.8161L59.9831 16.8924Z",
    fill: "#407BFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M62.4239 18.1678H50.3115L50.1445 17.3672H62.257L62.4239 18.1678Z",
    fill: "#407BFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.8143 19.4393H50.5771L50.4102 18.6387H60.6473L60.8143 19.4393Z",
    fill: "#407BFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.3994 11.8281H53.8008L53.9678 12.6245H65.5664L65.3994 11.8281Z",
    fill: "#407BFF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.1472 10.5518H53.5352L53.7021 11.3524H63.3099L63.1472 10.5518Z",
    fill: "#407BFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4121 9.28027H50.8281L50.9951 10.0766H61.579L61.4121 9.28027Z",
    fill: "#407BFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.9238 24.5352H51.6406L51.8076 25.3358H66.0908L65.9238 24.5352Z",
    fill: "#407BFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M57.2921 23.2637H51.375L51.542 24.06H57.459L57.2921 23.2637Z",
    fill: "#407BFF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.7139 23.2637H57.7969L57.9639 24.06H63.8809L63.7139 23.2637Z",
    fill: "#407BFF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.1423 21.9873H51.1094L51.2764 22.7879H64.3093L64.1423 21.9873Z",
    fill: "#407BFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.7835 28.3535H52.4375L52.6045 29.1541H63.9505L63.7835 28.3535Z",
    fill: "#407BFF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M55.4729 27.082H52.1719L52.3389 27.8827H55.6399L55.4729 27.082Z",
    fill: "#407BFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.6355 27.082H55.9258L56.0928 27.8827H60.8024L60.6355 27.082Z",
    fill: "#407BFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.9435 25.8066H51.9062L52.0732 26.6073H65.1062L64.9435 25.8066Z",
    fill: "#407BFF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.2275 29.3428H21.3477L21.5146 30.1434H30.3945L30.2275 29.3428Z",
    fill: "#407BFF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.6028 28.0713H21.082L21.249 28.8676H27.7655L27.6028 28.0713Z",
    fill: "#407BFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.579 28.0713H28.0625L28.2295 28.8676H34.7502L34.579 28.0713Z",
    fill: "#407BFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.8537 26.7949H20.8164L20.9834 27.5956H34.0163L33.8537 26.7949Z",
    fill: "#407BFF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M133.564 53.2637H128.066L128.709 61.5825H132.922L133.564 53.2637Z",
    fill: "#407BFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M133.564 53.2637H128.066L128.709 61.5825H132.922L133.564 53.2637Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13.756 47.4883H21.6596L18.9623 61.5828H11.0586L13.756 47.4883Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8221 43.7109H12.6602L15.7857 61.5817H26.9476L23.8221 43.7109Z",
    fill: "#407BFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12 43.7109H12.6594L15.7849 61.5817H15.1255L12 43.7109Z",
    fill: "#407BFF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 43.7109H12.6594L15.7849 61.5817H15.1255L12 43.7109Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3912 59.6685L14.9336 45.6211H22.2207L24.6741 59.6685H17.3912Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.3283 59.6685L21.875 45.6211H22.2218L24.6751 59.6685H24.3283Z",
    fill: "#407BFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4752 21.1926C79.6337 21.5363 79.5823 21.9015 79.3552 22.0046C79.128 22.1077 78.8194 21.9144 78.6609 21.575C78.5023 21.2356 78.558 20.8661 78.7809 20.763C79.0037 20.6599 79.3166 20.8317 79.4752 21.1926Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M79.611 21.8711C79.611 21.8711 79.7481 24.2168 79.3281 25.5744C80.1853 25.8622 81.111 25.1448 81.111 25.1448L79.611 21.8711Z",
    fill: "#FF5652"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5166 18.3526C79.4801 18.3828 79.4352 18.4008 79.388 18.4042C78.8222 18.4192 78.2979 18.7051 77.978 19.1732C77.9397 19.2452 77.8652 19.2904 77.7839 19.2913C77.7025 19.2922 77.6271 19.2485 77.5872 19.1774C77.5473 19.1063 77.5493 19.019 77.5923 18.9498C77.9863 18.3502 78.6465 17.9801 79.3623 17.9574C79.4584 17.9521 79.5471 18.0092 79.5821 18.099C79.6172 18.1889 79.5908 18.2911 79.5166 18.3526Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0945 20.6602C93.4188 25.2571 94.8973 28.8229 96.7016 30.8593C96.7016 30.8593 96.7359 34.4723 90.5945 36.1908C83.8402 38.0811 86.4288 33.7334 86.4288 33.7334C89.8573 31.8216 89.5316 28.9346 86.9516 27.8348L92.0945 20.6602Z",
    fill: "#FF8B7B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1326 29.9782C98.0126 28.2984 97.854 26.3823 96.8211 26.3307C95.6811 26.2792 89.0811 29.235 87.6711 31.3186C86.2611 33.4022 89.0168 35.4429 89.0168 35.4429L98.1326 29.9782Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6258 55.9918L78.9258 55.8027L79.0286 60.5887C79.0286 60.5887 84.0001 60.0731 84.2186 58.7628L84.6258 55.9918Z",
    fill: "#FF8B7B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9125 58.1524L75.3125 60.6012L79.0282 60.5926L78.9254 55.8066L75.9125 58.1524Z",
    fill: "#FF8B7B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M107.504 36.1047L107.384 37.3334C107.345 37.7287 107.294 38.1153 107.242 38.5063C107.144 39.2839 107.019 40.0615 106.887 40.8348C106.629 42.3857 106.295 43.9281 105.909 45.479C105.517 47.0596 105.042 48.6184 104.487 50.1489C104.191 50.9351 103.882 51.7213 103.514 52.5204C103.142 53.3586 102.713 54.1697 102.228 54.9477C102.112 55.1497 101.967 55.3774 101.825 55.5664C101.684 55.7554 101.547 55.996 101.397 56.1936C101.247 56.3913 101.088 56.6232 100.891 56.8252L100.612 57.1431C100.513 57.2604 100.407 57.3722 100.295 57.4782C99.4361 58.3215 98.4292 58.9988 97.3251 59.4759C95.6312 60.2043 93.8335 60.661 91.9979 60.8292C91.1622 60.928 90.3351 60.9667 89.5251 60.9882C88.7151 61.0096 87.9051 60.9882 87.1079 60.9452C86.3108 60.9022 85.5222 60.8335 84.7379 60.739C83.9537 60.6445 83.1908 60.5199 82.3594 60.3523L82.4965 55.8628C85.233 55.3831 87.938 54.7375 90.5965 53.9296C91.1878 53.7368 91.7686 53.5131 92.3365 53.2593C92.82 53.0548 93.2823 52.803 93.7165 52.5075C93.969 52.355 94.1831 52.1463 94.3422 51.8975L94.4665 51.6998C94.5241 51.6154 94.577 51.528 94.6251 51.4378C94.6862 51.3392 94.742 51.2373 94.7922 51.1327C94.8479 51.021 94.9079 50.9179 94.9637 50.7933C95.4671 49.6914 95.8813 48.5507 96.2022 47.3822C96.5537 46.1191 96.8837 44.8045 97.1494 43.4426C97.4151 42.0807 97.6722 40.7059 97.9079 39.3183L98.2337 37.2303L98.5294 35.1982L107.504 36.1047Z",
    fill: "#407BFF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.504 36.1047L107.384 37.3334C107.345 37.7287 107.294 38.1153 107.242 38.5063C107.144 39.2839 107.019 40.0615 106.887 40.8348C106.629 42.3857 106.295 43.9281 105.909 45.479C105.517 47.0596 105.042 48.6184 104.487 50.1489C104.191 50.9351 103.882 51.7213 103.514 52.5204C103.142 53.3586 102.713 54.1697 102.228 54.9477C102.112 55.1497 101.967 55.3774 101.825 55.5664C101.684 55.7554 101.547 55.996 101.397 56.1936C101.247 56.3913 101.088 56.6232 100.891 56.8252L100.612 57.1431C100.513 57.2604 100.407 57.3722 100.295 57.4782C99.4361 58.3215 98.4292 58.9988 97.3251 59.4759C95.6312 60.2043 93.8335 60.661 91.9979 60.8292C91.1622 60.928 90.3351 60.9667 89.5251 60.9882C88.7151 61.0096 87.9051 60.9882 87.1079 60.9452C86.3108 60.9022 85.5222 60.8335 84.7379 60.739C83.9537 60.6445 83.1908 60.5199 82.3594 60.3523L82.4965 55.8628C85.233 55.3831 87.938 54.7375 90.5965 53.9296C91.1878 53.7368 91.7686 53.5131 92.3365 53.2593C92.82 53.0548 93.2823 52.803 93.7165 52.5075C93.969 52.355 94.1831 52.1463 94.3422 51.8975L94.4665 51.6998C94.5241 51.6154 94.577 51.528 94.6251 51.4378C94.6862 51.3392 94.742 51.2373 94.7922 51.1327C94.8479 51.021 94.9079 50.9179 94.9637 50.7933C95.4671 49.6914 95.8813 48.5507 96.2022 47.3822C96.5537 46.1191 96.8837 44.8045 97.1494 43.4426C97.4151 42.0807 97.6722 40.7059 97.9079 39.3183L98.2337 37.2303L98.5294 35.1982L107.504 36.1047Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M82.196 41.8142C84.3211 50.9987 85.5171 60.3745 85.766 69.7995H110.859C110.996 66.6934 110.473 49.1779 107.949 36.5257C107.496 34.2105 106.132 32.1762 104.163 30.8825C102.195 29.5888 99.7902 29.1451 97.4917 29.6518L97.3717 29.6819C94.2389 30.395 89.7431 31.5464 87.086 32.556L86.9789 32.599C83.303 34.0317 81.2566 37.9745 82.196 41.8142Z",
    fill: "#407BFF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.8281 49.8482C84.0253 51.0554 84.2267 52.3357 84.411 53.6761C86.4638 51.528 87.1153 44.9463 87.1153 44.9463L83.8281 49.8482Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9819 56.3052L57.2862 55.7725L57.0977 60.5541C59.0163 61.085 61.0703 60.5041 62.4291 59.0461L62.9819 56.3052Z",
    fill: "#FF8B7B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5796 57.1816L52.7539 60.4682L57.1168 60.5541L57.3053 55.7725L54.5796 57.1816Z",
    fill: "#FF8B7B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6108 39.6106C91.2165 40.3625 90.865 41.0284 90.4708 41.7157C90.0765 42.4031 89.6993 43.0733 89.2922 43.7392C88.4865 45.0797 87.6508 46.3943 86.7679 47.696C84.9954 50.3618 83.0316 52.8946 80.8922 55.2745C79.7465 56.5557 78.5011 57.7437 77.1679 58.8274C77.0008 58.9692 76.8036 59.1067 76.6193 59.257C76.435 59.4074 76.2722 59.5277 75.9979 59.6866C75.7236 59.8456 75.4922 60.0046 75.2436 60.142C74.995 60.2795 74.7379 60.4041 74.485 60.5158C73.5397 60.9272 72.5504 61.2285 71.5365 61.4137C69.7631 61.7134 67.9557 61.7539 66.1708 61.534C65.3348 61.4379 64.5049 61.2945 63.685 61.1044C63.2765 61.0099 62.8736 60.9025 62.4765 60.7822C62.0479 60.6619 61.7008 60.5287 61.2422 60.3525L61.9493 55.9189C64.6408 55.5537 67.5508 55.0854 69.5565 54.1746C70.0017 53.9912 70.421 53.75 70.8036 53.4572C70.9577 53.3509 71.1012 53.2301 71.2322 53.0963C71.2622 53.0576 71.395 52.9416 71.4936 52.8471C71.5922 52.7526 71.7079 52.6624 71.815 52.5507C72.7324 51.6394 73.5913 50.6709 74.3865 49.6508C76.1119 47.4194 77.7239 45.1023 79.2165 42.7082C79.9879 41.4923 80.7379 40.2551 81.4879 39.0135L82.5936 37.1489L83.6608 35.3145L91.6108 39.6106Z",
    fill: "#407BFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7258 129.284H80.0372L77.6758 118.394H82.3686L84.7258 129.284Z",
    fill: "#FF8B7B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7753 128.279H85.0467C85.2348 128.286 85.3965 128.415 85.4453 128.597L86.371 132.782C86.4157 132.988 86.3637 133.203 86.23 133.365C86.0962 133.528 85.8954 133.62 85.6853 133.615C83.8467 133.585 82.951 133.478 80.6324 133.478C79.2053 133.478 77.3753 133.624 75.4081 133.624C73.441 133.624 73.1795 131.673 73.9853 131.497C77.6024 130.702 77.8424 129.611 79.0124 128.567C79.2222 128.38 79.4941 128.277 79.7753 128.279Z",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.3729 118.397H77.6758L78.9872 124.429L83.5901 124.013L82.3729 118.397Z",
    fill: "black"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5892 15.1347C92.3035 19.4824 93.4949 21.9441 92.3635 25.1018C90.6492 29.8491 84.5677 30.3303 81.6106 26.5754C78.9535 23.1943 76.6306 16.6513 79.9863 13.0554C81.4805 11.4345 83.7059 10.7055 85.8665 11.1292C88.0272 11.553 89.8145 13.0689 90.5892 15.1347Z",
    fill: "#FF8B7B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3552 21.6479C81.6523 22.5931 81.1123 23.3105 81.1123 23.3105C81.1123 23.3105 79.6681 19.7146 80.2209 18.0649C79.5181 16.6686 78.0995 18.7265 77.5638 16.007C77.0281 13.2875 79.3466 10.3661 80.2209 9.76039C80.311 10.0773 80.3515 10.4063 80.3409 10.7356C82.7034 8.81376 85.7059 7.86321 88.7409 8.07629C88.4872 8.45447 88.3257 8.88713 88.2695 9.33936C88.2695 9.33936 93.3566 10.1986 94.5138 13.0856C94.1045 12.8898 93.6727 12.7455 93.2281 12.656C94.1606 13.9963 94.5301 15.6505 94.2566 17.2615C93.8876 19.6109 93.6956 21.9848 93.6824 24.3631C93.7295 25.5832 90.3909 27.916 88.3552 25.4242C86.3195 22.9324 82.3552 21.6479 82.3552 21.6479Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4737 20.7112C84.7392 21.7239 84.6639 22.7961 84.2594 23.7615C83.7151 25.0503 82.5966 24.741 82.0437 23.6154C81.5423 22.6058 81.2209 20.7327 82.108 19.8348C82.9951 18.9369 84.1394 19.4954 84.4737 20.7112Z",
    fill: "#FF8B7B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2865 69.7822C93.2865 69.7822 71.4979 77.7044 70.8594 88.1827C69.6765 107.485 77.5494 122.767 77.5494 122.767L84.7665 121.994C84.7665 121.994 83.4808 115.781 82.5251 98.2959C81.3208 76.321 118.525 98.8115 110.862 69.7822H93.2865Z",
    fill: "#407BFF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93.2865 69.7822C93.2865 69.7822 71.4979 77.7044 70.8594 88.1827C69.6765 107.485 77.5494 122.767 77.5494 122.767L84.7665 121.994C84.7665 121.994 83.4808 115.781 82.5251 98.2959C81.3208 76.321 118.525 98.8115 110.862 69.7822H93.2865Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5515 120.103C75.5172 120.103 76.7001 123.316 76.7001 123.316L85.7001 122.431L85.2501 119.51L75.5515 120.103Z",
    fill: "#407BFF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4549 129.821H59.7621L58.3906 118.926H63.0835L64.4549 129.821Z",
    fill: "#FF8B7B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7296 128.274H64.8724C65.0637 128.272 65.2303 128.405 65.271 128.592L66.2053 132.773C66.2606 132.98 66.2153 133.202 66.0829 133.371C65.9506 133.54 65.7467 133.636 65.5324 133.632C63.6853 133.602 61.011 133.499 58.6753 133.503C55.9581 133.503 55.4396 133.653 52.2467 133.658C50.3181 133.658 49.7824 131.711 50.5881 131.509C54.2567 130.702 55.431 130.612 58.5981 128.648C58.9325 128.419 59.3248 128.289 59.7296 128.274Z",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.3984 118.93L59.1442 124.863L63.7984 124.545L63.0913 118.93H58.3984Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7666 69.7822C85.7666 69.7822 50.0666 72.9571 50.4523 90.9323C50.8509 109.629 57.8195 122.238 57.8195 122.238H64.788C64.788 122.238 63.468 112.538 63.7038 94.1329C63.7723 88.6209 74.8895 86.7994 85.7409 86.1549C95.118 85.5964 103.895 80.2391 107.538 71.548L108.288 69.7822H85.7666Z",
    fill: "#407BFF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.7666 69.7822C85.7666 69.7822 50.0666 72.9571 50.4523 90.9323C50.8509 109.629 57.8195 122.238 57.8195 122.238H64.788C64.788 122.238 63.468 112.538 63.7038 94.1329C63.7723 88.6209 74.8895 86.7994 85.7409 86.1549C95.118 85.5964 103.895 80.2391 107.538 71.548L108.288 69.7822H85.7666Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1841 120.361C56.1541 120.361 57.3798 123.592 57.3798 123.592L65.797 122.986L65.3041 120.064L56.1841 120.361Z",
    fill: "#407BFF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1372 49.5814L90.6072 67.0797C89.4489 71.5627 88.8642 76.1751 88.8672 80.806V88.9386C88.8672 90.9922 90.3758 92.6591 92.2401 92.6591H115.46C117.324 92.6591 118.833 90.9922 118.833 88.9386V80.806C118.831 76.1749 119.418 71.5625 120.577 67.0797L124.576 51.6135C125.193 49.2377 123.573 46.8877 121.331 46.8877H98.3772C96.8097 46.9371 95.4756 48.0464 95.1372 49.5814Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2553 84.1867L67.0138 88.5259C67.4167 90.8071 69.4181 92.6588 71.4881 92.6588H97.301C99.371 92.6588 100.73 90.8071 100.327 88.5259L99.5681 84.1867C99.1095 81.5875 96.8338 79.4824 94.4767 79.4824H69.7138C67.3395 79.4824 65.801 81.5875 66.2553 84.1867Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7867 97.0155H86.2653L84.9453 92.6592H101.107L99.7867 97.0155Z",
    fill: "#407BFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90.6133,
    y: 97.0156,
    width: 4.83,
    height: 32.3974,
    fill: "#407BFF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M95.4433 129.413H90.6133V97.793L95.4433 98.287V129.413Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M94.2622 129.413H93.1094V98.0469L94.2622 98.1672V129.413Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M104.133 134.422H81.9162C81.6506 134.42 81.4163 134.247 81.3346 133.994C81.2529 133.74 81.3422 133.463 81.5562 133.305L85.0791 130.728C86.7727 129.484 88.817 128.813 90.9162 128.812H95.1377C97.2355 128.814 99.2783 129.485 100.971 130.728L104.498 133.305C104.712 133.464 104.801 133.742 104.719 133.996C104.636 134.25 104.4 134.422 104.133 134.422Z",
    fill: "#407BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyAuditTrail);
export default __webpack_public_path__ + "static/media/easyAuditTrail.e4446755c2c24ddc45fb7371085ca740.svg";
export { ForwardRef as ReactComponent };